exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2_pCL{position:relative;display:inline-block;height:40px;padding:0 30px;vertical-align:middle;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:14px;line-height:1;text-align:center;text-decoration:none;border-radius:0;border:none;background-color:-wix-colors-mainButtonColor;color:-wix-colors-mainButtonTextColor;outline:none;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:opacity .2s}._2_pCL span{position:relative;z-index:1}._2_pCL:before{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;z-index:0;border-radius:inherit;background:#000;transition:opacity .2s;opacity:0}._2_pCL:hover:before{opacity:.1}._2_pCL:active:before{opacity:.2}._2_pCL._BRVx{color:#fff;background-color:#000}._2_pCL._BRVx:before{content:none}._2_pCL._BRVx:hover{opacity:.75}._2umQf{border-radius:999px}", ""]);

// exports
exports.locals = {
	"button": "_2_pCL",
	"disable-theme": "_BRVx",
	"disableTheme": "_BRVx",
	"rounded": "_2umQf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/components/button/button.styl
// module id = 1473
// module chunks = mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals widget/strip widget/classic widget/compact